<template>
  <div v-if="mq('small') || !onStartPage" :class="['vehicle-island', {'vehicle-island--parts-page': onPartsPage}]">
    <div class="vehicle-island__container">
      <div class="vehicle-selector">
        <template v-for="type in types">
          <a
            v-if="type.code !== null"
            :key="type.code"
            :class="['vehicle-selector__link', { 'vehicle-selector__link--selected': isSelected(type, 'type') }]"
            :href="type.url"
            @click="!redirectOnVehicleClick ? showOthersOrLoad($event, type, 'type', '#vehicle-brand') : null">

            <span class="vehicle-selector__link-icon">
              <oie-use-svg :svg="type.codeNameIcon" class="dropdown-expand__toggler-icon"></oie-use-svg>
            </span>

            <span>{{ type.name }}</span>
          </a>

          <button
            v-else-if="type.code === null"
            :key="type.name"
            ref="others"
            class="vehicle-selector__link"
            @click="showOthersOrLoad($event, type, 'type')">
            {{ type.name }}
          </button>
        </template>
      </div>
    </div>

    <section
      v-if="entities.type.selected"
      id="vehicle-brand"
      v-element-loader="{ endpoint: `vehicle/brand/selector` }"
      class="section-block--no-padding-container vehicle-model-selector__vehicle-section">
      <div class="section-block__top">
        <h2 class="section-block__header">
          {{ tStatic('titleVehicleSelectorChooseBrand') }} {{ entities.type.selected.name }}
        </h2>
      </div>

      <div
        id="vehicles-model-selector-list-content"
        aria-labelledby="vehicles-model-selector-list-toggler"
        aria-hidden="true"
        class="grid grid--four-fixed vehicle-model-selector__vehicle-grid vehicle-model-selector__vehicle-grid--brands">
        <div v-for="(brandChunk, i) in chunkedBrands" :key="`brand-chunk-${i}`">
          <a
            v-for="brand in brandChunk"
            :key="brand.code"
            :class="['navigational-item navigational-item--light-blue', { 'navigational-item--is-selected': isSelected(brand, 'brand') && !isLoading(brand.name), 'navigational-item--is-loading': isLoading(brand.name) }]"
            :href="brand.url"
            @click.prevent="showOthersOrLoad($event, brand, 'brand', '#vehicle-models')">
            {{ brand.name }}
          </a>
        </div>

        <div v-for="i of 3" :key="`vehicle-selector-brand-${i}`" class="grid__item--filler"></div>
      </div>

      <div
        id="vehicles-model-selector-list-content"
        aria-labelledby="vehicles-model-selector-list-toggler"
        aria-hidden="true"
        class="grid grid--four-fixed vehicle-model-selector__vehicle-grid">
        <div v-for="(brandChunk, i) in chunkedOtherBrands" :key="`brand-chunk-${i}`">
          <a
            v-for="brand in brandChunk"
            :key="brand.code"
            :class="['navigational-item navigational-item--light-blue', { 'navigational-item--is-selected': isSelected(brand, 'brand') && !isLoading(brand.name), 'navigational-item--is-loading': isLoading(brand.name) }]"
            :href="brand.url"
            @click.prevent="showOthersOrLoad($event, brand, 'brand', '#vehicle-models')">
            {{ brand.name }}
          </a>
        </div>

        <div v-for="i of 3" :key="`vehicle-selector-brand-${i}`" class="grid__item--filler"></div>
      </div>
    </section>

    <section
      v-if="entities.brand.selected"
      id="vehicle-models"
      v-element-loader="{ endpoint: `model/selector` }"
      class="section-block--no-padding-container vehicle-brand-models">
      <oie-section-block-top>
        <template v-slot:header>
          {{ tStatic('titleVehicleSelectorChooseModel') }} {{ entities.brand.selected.name }}

          <a v-if="brandInformation && brandInformation.name" class="vehicle-models__link" :href="brandInformation.data">{{ brandInformation.name }}</a>
        </template>

        <template v-slot:top-right>
          <input
            v-model="modelSearchText"
            type="search"
            class="vehicle-model-selector__filter-search js-vehicle-selector-filter-models"
            :placeholder="tStatic('titleVehicleSelectorFilterSearchPlaceholder')">
        </template>
      </oie-section-block-top>

      <div class="grid grid--four-fixed vehicle-model-selector__models-grid">
        <div v-for="(chunkModel, ci) in chunkedModels" :key="`chunkmodel-${ci}`">
          <template v-for="(model, i) in chunkModel">
            <a
              v-if="mq('to-small') && i < breakpointAccordion || showModels || mq('small')"
              :key="model.code"
              :href="model.url"
              class="navigational-item navigational-item--arrow navigational-item--light-blue">
              {{ model.name }}
            </a>
          </template>
        </div>

        <div v-for="i of 3" :key="`vehicle-selector-model-${i}`" class="grid__item--filler">
          {{ i }}
        </div>
      </div>

      <div v-if="mq('to-small') && filteredModels.length > breakpointAccordion" class="section-block__bottom">
        <button
          class="accordion-vehicle-list__toggle"
          aria-controls="vehicle-models"
          aria-expanded="false"
          @click="toggleModels()">
          <div v-if="!showModels" class="accordion-vehicle-list__toggle-inner accordion-vehicle-list__toggle-reveal">
            <oie-use-svg svg="expand-circle"></oie-use-svg>
            {{ tStatic('titleVehicleSelectorExpandModel') }}
          </div>

          <div v-if="showModels" class="accordion-vehicle-list__toggle-inner accordion-vehicle-list__toggle-dismiss">
            <oie-use-svg svg="desmiss-circle"></oie-use-svg>
            {{ tStatic('titleVehicleSelectorCloseLink') }}
          </div>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import httpService from '@/core/http-service'
import _ from 'lodash'
import utils from '@/core/utils'

export default {
  props: {
    redirectOnVehicleClick: {
      type: Boolean,
      default: false
    },
    onPartsPage: {
      type: Boolean,
      default: false
    },
    onStartPage: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    entities: {
      type: { selected: null, childType: 'brand' },
      brand: { selected: null, childType: 'model' },
      model: {}
    },
    types: [],
    brands: [],
    models: [],
    showOtherBrands: false,
    modelSearchText: null,
    showModels: false,
    brandInformation: null,
    chunkSplit: 4,
    isLoadingEntity: null
  }),
  computed: {
    selectedUrlCodes() {
      const selectedVehicle = this.clientModel.selectedVehicle
      const selectedBrand = this.clientModel.selectedBrand
      return selectedVehicle ? { selectedVehicle, selectedBrand } : null
    },
    breakpointAccordion() {
      return this.mq('medium') ? 12 : 6
    },
    filteredModels() {
      return _.filter(this.models, m => !this.modelSearchText || (m.name || '').toLowerCase().indexOf(this.modelSearchText.toLowerCase()) > -1)
    },
    chunkedBrands() {
      return this.createChunks(_.filter(this.brands, b => !b.otherBrands.length))
    },
    chunkedOtherBrands() {
      const container = _.find(this.brands, b => _.get(b, 'otherBrands.length'))
      if(!container) { return [[]] }
      return this.showOtherBrands ? this.createChunks(container.otherBrands) : [[container]]
    },
    chunkedModels() {
      return this.createChunks(this.filteredModels)
    }
  },
  watch: {
    'entities.type.selected'(entity) {
      this.showOtherBrands = false
      if(entity && entity.code) {
        this.entities.brand.selected = null
        this.updateUrlAndBreadcrumb(entity)
      }
    },
    'entities.brand.selected'(entity) {
      if(entity && entity.code) {
        this.modelSearchText = ''
        this.updateUrlAndBreadcrumb(entity)
        httpService.get(`vehicle/brand/information/${entity.code}`).then(({ data }) => {
          this.brandInformation = data
        })
      }
    }
  },
  mounted() {
    this.get('type', 'fordon').then(({ data }) => {
      this.types = data
      if(this.selectedUrlCodes) {
        this.loadExistingSelections()
      }
    })
  },
  methods: {
    isSelected(entity, type) {
      return this.entities[type].selected === entity
    },
    isLoading(name) {
      return this.isLoadingEntity === name
    },
    loadExistingSelections() {
      const otherTypesContainer = _.find(this.types, t => t.otherTypes.length > 0)
      const otherTypeMatch = _.find(otherTypesContainer.otherTypes, t => t.code === this.selectedUrlCodes.selectedVehicle)
      if(otherTypesContainer && otherTypeMatch) {
        this.showOthersOrLoad(null, otherTypesContainer, 'type')
      }
      this.entities.type.selected = otherTypeMatch || _.find(this.types, t => t.code === this.selectedUrlCodes.selectedVehicle)

      this.get('brand', this.selectedUrlCodes.selectedVehicle).then(() => {
        if(this.selectedUrlCodes.selectedBrand) {
          // possible todo later: handle other
          this.entities.brand.selected = _.find(this.brands, t => t.code === this.selectedUrlCodes.selectedBrand)
          this.get('model', this.selectedUrlCodes.selectedBrand)
        }
      })
    },
    redirectTo(url) {
      window.location = url
    },
    get(type, selector) {
      return httpService.get(`vehicle/${type}/selector/${selector}`).then(response => {
        this[type + 's'] = response.data
        return response
      })
    },
    async showOthersOrLoad(event, entity, type, scrollToElement) {
      if (event) {
        event.preventDefault()
      }

      const pluralizedType = type + 's'
      const others = _.get(entity, `other${_.upperFirst(pluralizedType)}`)

      if(others.length > 0) {
        if(type === 'brand') {
          this.showOtherBrands = true
        } else {
          this[pluralizedType].push(...others)
          this[pluralizedType].remove(entity)
        }
      } else {
        this.isLoadingEntity = entity.name
        this.toggleModels(false)
        this.entities[type].selected = entity
        const selectedTypeCode = _.get(this.entities, [type, 'selected', 'code'])
        const entities = await this.get(this.entities[type].childType, selectedTypeCode)
        this.isLoadingEntity = null

        this.$scrollTo(scrollToElement, 500, { offset: this.mq('to-medium') ? -70 : -130 })

        return entities
      }
    },
    updateUrlAndBreadcrumb(entity) {
      if(entity) {
        utils.pushState(entity.url)
        httpService.get(`vehicle/breadcrumb/${entity.code}`).then(({ data }) => {
          this.publish('breadcrumb.update', data.breadCrumbList)
        })
      }
    },
    toggleModels(value) {
      this.showModels = value !== undefined ? value : !this.showModels
    },
    toggleSelector() {
      this.selectorIsOpen = !this.selectorIsOpen
    },
    createChunks(data) {
      const chunkSizes = { 'to-small': 1, 'to-medium': 2, 'to-large': 3, 'large': 4 }
      const matchingChunk = _.chain(_.keys(chunkSizes)).map(key => ({ value: this.breakpoints[key], key })).find(item => item.value).value()

      return matchingChunk ? _.chunk(data, Math.ceil(data.length / chunkSizes[matchingChunk.key])) : [data]
    }
  }
}
</script>

<style lang="scss">
$vehicle-link-height: 3.8125rem;

.vehicle-model-selector {
  @include container;
  margin-top: measure(full);
}

.vehicle-model-selector__vehicle-grid {
  grid-gap: measure(eighth) measure(grid-gap) !important;
  overflow: hidden;
}

.grid.vehicle-model-selector__vehicle-grid--brands {
  margin-bottom: measure(full);
}

.vehicle-model-selector__vehicle-grid[aria-hidden="false"] {
  max-height: 500rem;

  @include media(medium) {
    max-height: 50rem;
  }
}

.vehicle-model-selector__vehicle-section.section-block--no-padding-container {
  margin-top: measure(full);
  margin-bottom: measure(half);
  padding-bottom: measure(full);
}

.vehicle-model-selector__models-grid {
  grid-gap: measure(eighth) measure(grid-gap) !important;
  overflow: hidden;
}

.vehicle-model-selector__models-grid[aria-hidden="false"] {
  max-height: 400rem;

  @include media(medium) {
    max-height: 50rem;
  }
}

.vehicle-model-selector__filter-search {
  display: block;
  width: 100%;
  height: 3.125rem;
  border: 1px solid color(border-gray);
  padding: 0 measure(half);
}

.vehicle-brand-models {
  padding-top: measure(full);
  border-top: 1px solid color(border-gray);
}

.vehicle-models__link {
  @include body;
  @include reset-link;

  @include media(to-small) {
    display: flex;
    flex-direction: column;
    margin-top: measure(quarter);
  }

  @include media(small) {
    margin-left: measure(half);
  }
}
</style>
